module.exports = "<button *ngIf=\"selectedProject\" class=\"button-header button-project-list\" (click)=\"gotoProjects()\">Projects List</button>\n<auth></auth>\n<h3>Jsonforms Swagger</h3>\n<button *ngIf=\"!user\" class=\"button-header button-login-github\" (click)=\"loginWithGithub()\">Login With Github</button>\n<div *ngIf=\"user\" class=\"user-menu\">\n    <h4 (click)=\"logout()\">{{user.displayName}}</h4>\n    <img src=\"{{user.photoURL}}\" (click)=\"logout()\" />\n</div>";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/components/header/header.html
 ** module id = 751
 ** module chunks = 0
 **/